// extracted by mini-css-extract-plugin
export default {"fortune500Boards":"Ftse100Boards_fortune500Boards__otYl8","fortune500Title":"Ftse100Boards_fortune500Title__W3z9E","fortune500BoardsList":"Ftse100Boards_fortune500BoardsList__a1kvV"};